import React, {useContext, useEffect, useRef} from "react";
import AppContext from "../context/AppContext";
import {Link, useLocation, useNavigate} from "react-router-dom";
import './Header.scss'

export default () => {
    const { currentDir, darkMode, setDarkMode, startIndexing, loadDirectory } = useContext(AppContext)
    const location = useLocation()
    const navigate = useNavigate()
    const searchRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        const down = (e: KeyboardEvent) => {
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault()
                searchRef.current?.focus()
            }
        }
        window.addEventListener('keydown', down)
        return () => window.removeEventListener('keydown', down)
    }, [])

    const onToggleTheme = (e: React.MouseEvent) => {
        e.preventDefault()
        setDarkMode(!darkMode)
    }

    const onSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            const val = (e.target as HTMLInputElement).value.trim()
            if (val) navigate(`/search/${val}`)
        }
    }

    const onIndex = (e: React.MouseEvent) => {
        e.preventDefault()
        if (window.confirm('Re-index ' + (currentDir?.name || 'all directories') + '?')) {
            startIndexing()
        }
    }

    const path = location.pathname
    const isLib   = path === '/' || path.startsWith('/dir/')
    const isTags  = path.startsWith('/tags')
    const isFavs  = path.startsWith('/favourites')
    const isDupes = path.startsWith('/duplicates')

    const buildBreadcrumb = () => {
        if (!currentDir) return null
        const parents = currentDir.parents ? [...currentDir.parents].reverse() : []
        return (
            <nav className="hdr-breadcrumb" aria-label="breadcrumb">
                <a href="/" onClick={e => { e.preventDefault(); loadDirectory(e, null) }} className="hdr-crumb">Library</a>
                {parents.map(p => (
                    <React.Fragment key={p.hash}>
                        <span className="hdr-sep">›</span>
                        <a href={`/dir/${p.hash}`} onClick={e => loadDirectory(e, p)} className="hdr-crumb">{p.name}</a>
                    </React.Fragment>
                ))}
                <span className="hdr-sep">›</span>
                <span className="hdr-current">{currentDir.name}</span>
            </nav>
        )
    }

    const defaultSearchVal = path.startsWith('/search/') ? decodeURIComponent(path.split('/search/')[1] || '') : ''

    return (
        <header id="app-header">
            <Link to="/" className="hdr-brand" onClick={e => { loadDirectory(e, null) }}>memo</Link>

            <nav className="hdr-nav">
                <Link to="/"            className={'hdr-tab' + (isLib  ? ' active' : '')}>Library</Link>
                <Link to="/tags"        className={'hdr-tab' + (isTags ? ' active' : '')}>Tags</Link>
                <Link to="/favourites"  className={'hdr-tab' + (isFavs ? ' active' : '')}>Favourites</Link>
                <Link to="/duplicates"  className={'hdr-tab' + (isDupes ? ' active' : '')}>Dupes</Link>
            </nav>

            <div className="hdr-mid">
                {currentDir ? buildBreadcrumb() : null}
            </div>

            <div className="hdr-search">
                <span className="hdr-search-icon">⌕</span>
                <input
                    ref={searchRef}
                    type="text"
                    placeholder="Search…"
                    defaultValue={defaultSearchVal}
                    onKeyDown={onSearch}
                />
            </div>

            <div className="hdr-actions">
                <button className="hdr-btn" title="Re-index" onClick={onIndex}>↺</button>
                <button className="hdr-btn" title="Toggle theme" onClick={onToggleTheme}>
                    {darkMode ? '☀' : '◑'}
                </button>
            </div>
        </header>
    )
}
